<!--
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     数据下载模块
  +--------------------------------------------------------------------------------------
-->

<template>
  <div class="rms-overview">
    <div class="main-header flex justify-content-center">
      <div class="title"><f-back></f-back>{{ $route.meta.title }}</div>
    </div>
    <div class="data">
      <RmsDownloadPage />
    </div>
  </div>
</template>

<script>
export default {

  components: {
    RmsDownloadPage: () => import('./components/RmsDownloadPage')
  },

  data() {
    return {
    }
  },

  created() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
/deep/ .main-header {
  .title {
    flex: none;
    width: 1200px;
    font-size: 20px;
  }
}
  .data {
    width: 100%;
    display: flex;
    justify-content: center;
    /deep/ .el-card {
      width: 1200px;
    }
  }
</style>
